import { foremanRoute } from '@utils/consts';
import { ProtectedRoute } from '@components/protectedRoute';
import { Outlet } from 'react-router';
import { ForemanNavbarProvider } from '@contexts/foreman/navbar';
import { foremanOtherRoutes } from './other/routes';
import { foremanSchedulesRoutes } from './schedules/routes';
import { foremanSearchRoutes } from './search/routes';

export const foremanRoutes = [
  {
    path: foremanRoute.index,
    lazy: async () => ({
      Component: () => (
        <ProtectedRoute>
          <ForemanNavbarProvider>
            <Outlet />
          </ForemanNavbarProvider>
        </ProtectedRoute>
      ),
    }),
    children: [...foremanOtherRoutes, ...foremanSchedulesRoutes, ...foremanSearchRoutes],
  },
];
